'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, add_html_tooltip, activate_tooltips, ajax_post, echo, ajax_success_next_handler,
} = pubdb;
const {
    fields, location,
} = window;


$(function () {
    fields.forEach(function ([name, required, description]) {
        const label = $('label[for="' + name + '"]');
        if (required) {
            $('<div class="tooltip">Pflichtfeld</div>').prependTo(label);
            activate_tooltips($('<strong style="color:crimson; font-size:140%">*\xA0</strong>').prependTo(label));
        }
        if (description) {
            add_html_tooltip(label, description);
        }
    });

    const main_form = $('#main_form');
    main_form.on('submit', ev => {
        ev.preventDefault();

        const data = { csrf_token: pubdb.csrf_token };
        ['en', 'de', 'description', 'bemerkung', 'id'].forEach(key => {
            data[key] = $(`[name="${key}"]`, main_form).val();
        });

        ajax_post(main_form.attr('action'), data, req_success, req_error);

        function req_error (data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        function req_success (resp) {
            ajax_success_next_handler(resp, 'fpkeyword');
        }
    });
});
